import { React } from "react";
import { InputField } from "../../../../../components/controls/InputField";
import _ from "lodash";
import {
  CheckboxControl,
  DatePickerControl,
  SelectListControl,
} from "../../../../../components/controls";
import Loading from "../../../../../components/Loading";
import {
  getFieldName,
  getPosition,
  getValue,
} from "../../../../../utilities/ObservationConfigUtils";

export default function UserPositionRubricMap({
  name,
  observationConfig,
  updateUserPositionRubricMap,
  formattedTeacherObservationRubrics,
  formattedAdminObservationRubrics,
  updateObservationConfigs,
  adminSurveyList,
  teacherSurveyList,
  updateUserPositionSurveyTemplateMap,
  defaultUserPositionTypes,
}) {
  console.log(observationConfig);
  return (
    <div className="observation-component">
      <div className="config-wrapper">
        {_.map(
          name === "Teacher"
            ? getPosition(40, 50, defaultUserPositionTypes)
            : getPosition(10, 30, defaultUserPositionTypes),
          (userPosition, index) => {
            return (
              <div className="user-position-row" key={index}>
                <InputField
                  subTitle={
                    userPosition?.label.replace(/([A-Z])/g, " $1").trim() +
                    " Rubric"
                  }
                  value={
                    _.find(
                      observationConfig?.UserPositionRubricMap,
                      (x) =>
                        x.UserPosition === userPosition.value &&
                        x.RubricType === 1
                    )?.RubricId
                  }
                  fieldName={userPosition.value}
                  onChange={(value, fieldName) =>
                    updateUserPositionRubricMap(value, fieldName, 1)
                  }
                >
                  {(name === "Teacher" && formattedTeacherObservationRubrics) ||
                  (name === "Admin" && formattedAdminObservationRubrics) ? (
                    <SelectListControl
                      textValuePairs={
                        name === "Teacher"
                          ? formattedTeacherObservationRubrics
                          : formattedAdminObservationRubrics
                      }
                      hidePleaseSelect={true}
                    />
                  ) : (
                    <div className="select-loading-wrapper">
                      <Loading />
                    </div>
                  )}
                </InputField>
              </div>
            );
          }
        )}
        <InputField
          subTitle="Survey Type"
          value={parseInt(
            getValue(observationConfig, name, "*SurveyDisplayType")
          )}
          fieldName={getFieldName(name, "*SurveyDisplayType")}
          onChange={updateObservationConfigs}
        >
          <SelectListControl
            textValuePairs={[
              { text: "Benchmark", value: 1 },
              { text: "Final", value: 2 },
            ]}
            hidePleaseSelect={true}
          />
        </InputField>
        <InputField
          subTitle="Amount of Evaluations"
          value={getValue(observationConfig, name, "NumberOf*Evals")}
          onChange={updateObservationConfigs}
          fieldName={getFieldName(name, "NumberOf*Evals")}
        />
        <InputField
          subTitle="Disable Self-Reflection"
          value={getValue(observationConfig, name, "DisableSelfReflection*")}
          onChange={updateObservationConfigs}
          fieldName={getFieldName(name, "DisableSelfReflection*")}
        >
          <CheckboxControl />
        </InputField>
      </div>
      <div className="config-wrapper">
        {_.map(
          name === "Teacher"
            ? getPosition(40, 50, defaultUserPositionTypes)
            : getPosition(10, 30, defaultUserPositionTypes),
          (userPosition, index) => {
            const surveyType = name === "Teacher" ? 4 : 5;
            return (
              <div className="user-position-row" key={index}>
                <InputField
                  subTitle={
                    userPosition?.label.replace(/([A-Z])/g, " $1").trim() +
                    " Survey Template"
                  }
                  value={
                    _.find(
                      observationConfig?.UserPositionSurveyTemplateMap,
                      (x) =>
                        x.UserPosition === userPosition.value &&
                        x.SurveyType === surveyType
                    )?.SurveyTemplateId
                  }
                  fieldName={userPosition.value}
                  onChange={(value, fieldName) =>
                    updateUserPositionSurveyTemplateMap(
                      value,
                      fieldName,
                      surveyType
                    )
                  }
                >
                  {(name === "Teacher" && teacherSurveyList) ||
                  (name === "Admin" && adminSurveyList) ? (
                    <SelectListControl
                      textValuePairs={_.map(
                        name === "Teacher"
                          ? teacherSurveyList
                          : (adminSurveyList ?? []),
                        (x) => {
                          return { Text: x.Title, Value: x.Id };
                        }
                      )}
                      hidePleaseSelect={true}
                    />
                  ) : (
                    <Loading />
                  )}
                </InputField>
              </div>
            );
          }
        )}
        <InputField
          subTitle="Start Date"
          value={
            getValue(observationConfig, name, "*SurveyStartDate") !== undefined
              ? getValue(observationConfig, name, "*SurveyStartDate")
              : ""
          }
          maxLength={100}
          onChange={updateObservationConfigs}
          fieldName={getFieldName(name, "*SurveyStartDate")}
        >
          <DatePickerControl
            includeTime={true}
            minDate={new Date().toISOString().slice(0, 10)}
          />
        </InputField>
        <InputField
          subTitle="End Date"
          value={
            getValue(observationConfig, name, "*SurveyEndDate") !== undefined
              ? getValue(observationConfig, name, "*SurveyEndDate")
              : ""
          }
          maxLength={100}
          onChange={updateObservationConfigs}
          fieldName={getFieldName(name, "*SurveyEndDate")}
        >
          <DatePickerControl
            includeTime={true}
            minDate={new Date().toISOString().slice(0, 10)}
          />
        </InputField>
      </div>
    </div>
  );
}
